<template>
  <div class="vx-row">
    <div class="w-full vx-col">

      <vx-card :title="'MANAGE REPORTS'" class="">

        <div id="chart-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="charts">
              <template slot="thead">
                <vs-th width="50%">NAME</vs-th>
                <vs-th width="20%">UPDATED BY</vs-th>
                <vs-th width="20%">UPDATED AT</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickUpdate(tr)" class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].updated_by">
                    {{ data[indextr].updated_by || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].updated_at">
                    {{ data[indextr].updated_at ? __dateTimeFormatter(data[indextr].updated_at)  : 'N/A' }}
                  </vs-td>

                  <vs-td>
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr])"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <update-chart-manage-pop-up ref="updateChartManagePopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import UpdateChartManagePopUp from "@/components/popups/settings/charts/UpdateChartManagePopUp";

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  const ReportingRepository = RepositoryFactory.get('reporting');

  export default {
    name: "ChartsSettings",
    data() {
      return {
        charts: [],
      }
    },
    components: {
      UpdateChartManagePopUp
    },
    methods: {
      async refreshData() {
        await this.fetchChartManageList()
      },
      async fetchChartManageList() {
        await this.$vs.loading({
          container: '#chart-list-table',
          scale: 0.45
        })
        try {
          const {data} = await ReportingRepository.getListOfChartManage()
          this.charts =  data.data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#chart-list-table > .con-vs-loading')
      },
      async onClickUpdate(data) {
        await this.$refs.updateChartManagePopUp.openPopup(data)
      },
    },
    async mounted() {
      await this.fetchChartManageList()
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>
